import * as React from 'react';
import { translate, Trans } from 'react-i18next';
import Hint from 'wix-ui-icons-common/Hint';
import * as s from './TeamAndSiteOwnerHint.scss';
import { getTeamName, getIsTeamOwnerAndSiteOwner } from '../../redux/selectors/teamDetails';
import { State } from '../../redux/configure-store';
import { useSelector, useDispatch } from 'react-redux';
import { SHOW_TEAM_AND_SITE_OWNER_HINT, HIDE_TEAM_AND_SITE_OWNER_HINT } from '../../redux/actions/action-types';
import { useEffect, useCallback } from 'react';

import { FloatingNotification, Text, TextButton } from 'wix-style-react';

export const TeamAndSiteOwnerHint: React.FC = () => {
  const dispatch = useDispatch();
  const { showTeamAndSiteOwnerHint, isTeamOwnerAndSiteOwner, teamName } = useSelector((state: State) => (
    {
      teamName: getTeamName(state),
      showTeamAndSiteOwnerHint: state.showTeamAndSiteOwnerHint,
      isTeamOwnerAndSiteOwner : getIsTeamOwnerAndSiteOwner(state)
    }));

  const onShowTeamAndSiteOwnerHint = useCallback((show: boolean) => {
    dispatch({ type: show ? SHOW_TEAM_AND_SITE_OWNER_HINT : HIDE_TEAM_AND_SITE_OWNER_HINT });
  }, [dispatch]);

  useEffect (() => {
    if (isTeamOwnerAndSiteOwner && showTeamAndSiteOwnerHint === null) {
      onShowTeamAndSiteOwnerHint(true);
    }
  }, [isTeamOwnerAndSiteOwner, showTeamAndSiteOwnerHint]);

  return (
    (!showTeamAndSiteOwnerHint || !isTeamOwnerAndSiteOwner) ?
    null :
    <div className={s.hintWrapper}>
      <FloatingNotification
        dataHook="team-and-site-owner-hint"
        width="100%"
        text={<Trans i18nKey="app.teamAndSiteOwnerHint" values={{ teamName }}>
                <Text weight="normal">0</Text>
                <Text>1</Text>
                <TextButton as="a" href="https://www.wix.com/account/team">2</TextButton>
                <Text>3</Text>
              </Trans>}
        prefixIcon={<Hint />}
        onClose={() => onShowTeamAndSiteOwnerHint(false)}
      />
    </div>
  );
};

export default translate()(TeamAndSiteOwnerHint);
